import {Statistics} from '../../modules'

export const StatisticPage = () => {
  return <Statistics />
}
